import { useTranslation } from 'react-i18next';

/**
 * Maps a raw backend gender string ("male"/"female", any casing) to the active
 * language's label, reusing the already-translated `assetPicker.gender*` keys so
 * no new translation work is needed.
 *
 * Casing is preserved as-is from the locale (the en values are lowercase
 * "male"/"female"), so callers keep their existing presentation: e.g. an avatar
 * card with a `capitalize` CSS class still renders "Male", while a voice-card
 * meta line keeps it lowercase — exactly as before, just localized.
 *
 * Unknown / empty / other values (e.g. "unknown", "neutral") pass through
 * unchanged so nothing ever disappears.
 *
 * Usage: `const genderLabel = useGenderLabel();` then `genderLabel(a.gender)`.
 */
export function useGenderLabel() {
  const { t } = useTranslation('v2');
  return (gender?: string | null): string => {
    const g = (gender || '').trim().toLowerCase();
    if (g === 'female') return t('assetPicker.genderFemale');
    if (g === 'male') return t('assetPicker.genderMale');
    return gender || '';
  };
}
